/**
 * Internationalization Configuration (Rule REQ-099)
 * Default: Indonesian (id). Selectable: English (en).
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const resources = {
  id: {
    translation: {
      app: {
        title: 'Hermes Virtual Office',
        tagline: 'Kantor Virtual 2D untuk Pemilik & Agen AI',
      },
      nav: {
        office: 'Kantor',
        tasks: 'Tugas',
        inbox: 'Kotak Masuk',
        reports: 'Laporan',
        more: 'Lainnya',
      },
      hud: {
        activeRuns: 'Tugas Jalan',
        pendingApprovals: 'Persetujuan',
        errors: 'Galat',
        agentsOnline: 'Agen Online',
        ticker: 'Aktivitas Langsung',
        tickerWaiting: 'Menunggu aktivitas agen...',
        connected: 'Online',
        disconnected: 'Terputus',
      },
      rooms: {
        command: 'Pusat Komando',
        social: 'Studio Sosial',
        sales: 'Lantai Sales',
        finance: 'Ruang Finansial',
        marketing: 'Lab Pemasaran',
        analytics: 'Pusat Analitik',
        support: 'Meja Support',
        hr: 'Ruang Rekrutmen',
        lounge: 'Ruang Istirahat',
        approvalGate: 'Gerbang Persetujuan',
        all: 'Semua Ruang',
      },
      status: {
        idle: 'Santai',
        thinking: 'Berpikir',
        working: 'Bekerja',
        waiting_approval: 'Menunggu Persetujuan',
        error: 'Galat',
        offline: 'Offline',
      },
      office: {
        askOffice: 'Tanya Kantor',
        demoBadge: 'DEMO',
        emptyTitle: 'Kantor Virtual Masih Kosong',
        emptyDesc: 'Belum ada agen AI yang aktif di kantor ini. Muat kantor demo untuk melihat simulasi penempatan agen di seluruh divisi.',
        loadDemo: 'Muat Kantor Demo',
        loadingDemo: 'Menyiapkan agen demo...',
        orchestratorTitle: 'Orkestrator Kantor',
        orchestratorDesc: 'Kirim instruksi langsung ke Kepala Komando.',
        rooms: {
          command: 'Pusat Komando',
          social: 'Studio Sosial',
          sales: 'Lantai Sales',
          finance: 'Ruang Finansial',
          marketing: 'Lab Pemasaran',
          analytics: 'Pusat Analitik',
          support: 'Meja Support',
          hr: 'Ruang Rekrutmen',
          lounge: 'Ruang Istirahat',
          approvalGate: 'Gerbang Persetujuan',
          all: 'Semua Ruang',
        },
      },
      power: {
        label: 'Mode Hemat Daya',
        active: 'Hemat Daya Aktif (Animasi Dinonaktifkan)',
        toggle: 'Alihkan Hemat Daya',
      },
      tasks: {
        filterAll: 'Semua',
        filterManual: 'Langsung',
        filterChat: 'Dari Chat',
        /* Audit 2026-10-21 — hentikan / edit / hapus tugas */
        stopTask: 'Hentikan',
        stopFailed: 'Gagal menghentikan tugas.',
        editTask: 'Edit Tugas',
        deleteTask: 'Hapus',
        deleteConfirm: 'Hapus "{{name}}"? Tindakan ini tidak dapat dibatalkan.',
        deleteFailed: 'Gagal menghapus tugas.',
        editFailed: 'Gagal menyimpan perubahan tugas.',
        editTitleRequired: 'Judul wajib diisi.',
        editSave: 'Simpan Perubahan',
        saving: 'Menyimpan...',
        editTitle: 'Judul',
        editDescription: 'Keterangan',
        editPriority: 'Prioritas',
        editAssignee: 'Ditujukan ke',
        badgeChat: 'Chat Auto-Task',
        badgeDirect: 'Direct',
        toolCalls: 'tool',
        toolCallsPlural: 'tools',
        tabResult: 'Hasil Output',
        tabEvents: 'Timeline Run',
        noEvents: 'Belum ada riwayat aktivitas run tercatat.',
        noResult: 'Belum ada hasil tertulis untuk tugas ini.',
        loadingEvents: 'Memuat timeline run...',
        close: 'Tutup',
        viewResult: 'Hasil',
        viewTimeline: 'Timeline',
        runNow: 'Jalankan',
        running: 'Menjalankan...',
        statusRunning: 'Berjalan',
        needsApproval: 'Persetujuan',
        empty: 'Kosong',
        createTask: 'Buat Tugas',
      },
      cron: {
        title: 'Jadwal Otomatis',
        tabBoard: 'Papan Tugas',
        tabCron: 'Jadwal Cron',
        empty: 'Belum ada jadwal tugas otomatis yang terdaftar di gateway.',
        active: 'Aktif',
        paused: 'Dijeda',
        lastRun: 'Terakhir dijalankan',
        nextRun: 'Jadwal berikutnya',
        assignedTo: 'Penanggung Jawab',
        schedule: 'Jadwal Rutin',
        skills: 'Keahlian Terkait',
      },
      messenger: {
        title: 'Obrolan Agen',
        searchPlaceholder: 'Cari agen atau divisi...',
        activeAgent: 'Sedang Dibuka',
        noSpeech: 'Belum ada obrolan terkini',
        allAgents: 'Semua Agen',
        switchAgent: 'Ganti Agen',
        emptySearch: 'Tidak ada agen yang cocok dengan pencarian.',
      },
      modelPriority: {
        title: 'Prioritas model',
        help: 'Model pertama menjadi model utama agen. Maksimal {{max}} model unik.',
        loading: 'Memuat prioritas model...',
        primary: 'Utama',
        up: 'Naikkan {{model}}',
        down: 'Turunkan {{model}}',
        remove: 'Hapus {{model}}',
        save: 'Simpan prioritas',
        saving: 'Menyimpan prioritas...',
        saved: 'Prioritas model tersimpan.',
        loadError: 'Gagal memuat prioritas model.',
        saveError: 'Gagal menyimpan prioritas model.',
        mismatch: 'Prioritas yang terbaca belum sesuai. Coba simpan lagi.',
        retry: 'Coba lagi',
        empty: 'Belum ada prioritas model. Tambahkan model terdeteksi.',
        select: 'Pilih model terdeteksi',
        add: 'Tambah model',
        noModels: 'Belum ada model terdeteksi. Uji koneksi untuk memuat pilihan.',
        limit: 'Batas {{max}} model tercapai.',
      },
      lang: {
        switch: 'Ganti Bahasa',
        id: 'Bahasa Indonesia',
        en: 'English',
      },
    },
  },
  en: {
    translation: {
      app: {
        title: 'Hermes Virtual Office',
        tagline: '2D Virtual Office for CEO & AI Agents',
      },
      nav: {
        office: 'Office',
        tasks: 'Tasks',
        inbox: 'Inbox',
        reports: 'Reports',
        more: 'More',
      },
      hud: {
        activeRuns: 'Active Runs',
        pendingApprovals: 'Approvals',
        errors: 'Errors',
        agentsOnline: 'Online Agents',
        ticker: 'Live Stream',
        tickerWaiting: 'Waiting for agent events...',
        connected: 'Online',
        disconnected: 'Disconnected',
      },
      rooms: {
        command: 'Command Center',
        social: 'Social Studio',
        sales: 'Sales Floor',
        finance: 'Finance Vault',
        marketing: 'Marketing Lab',
        analytics: 'Analytics Hub',
        support: 'Support Desk',
        hr: 'Recruitment Room',
        lounge: 'Lounge',
        approvalGate: 'Approval Gate',
        all: 'All Rooms',
      },
      status: {
        idle: 'Idle',
        thinking: 'Thinking',
        working: 'Working',
        waiting_approval: 'Needs Approval',
        error: 'Error',
        offline: 'Offline',
      },
      office: {
        askOffice: 'Ask Office',
        demoBadge: 'DEMO',
        emptyTitle: 'Virtual Office is Empty',
        emptyDesc: 'No AI agents are currently active in this office. Load demo office to preview agents across all departments.',
        loadDemo: 'Load Demo Office',
        loadingDemo: 'Setting up demo agents...',
        orchestratorTitle: 'Office Orchestrator',
        orchestratorDesc: 'Send instructions directly to Command Chief.',
        rooms: {
          command: 'Command Center',
          social: 'Social Studio',
          sales: 'Sales Floor',
          finance: 'Finance Vault',
          marketing: 'Marketing Lab',
          analytics: 'Analytics Hub',
          support: 'Support Desk',
          hr: 'Recruitment Room',
          lounge: 'Lounge',
          approvalGate: 'Approval Gate',
          all: 'All Rooms',
        },
      },
      power: {
        label: 'Low Power Mode',
        active: 'Low Power Active (Animations Paused)',
        toggle: 'Toggle Low Power',
      },
      tasks: {
        filterAll: 'All',
        filterManual: 'Direct',
        filterChat: 'From Chat',
        /* Audit 2026-10-21 — stop / edit / delete a task */
        stopTask: 'Stop',
        stopFailed: 'Failed to stop the task.',
        editTask: 'Edit Task',
        deleteTask: 'Delete',
        deleteConfirm: 'Delete "{{name}}"? This action cannot be undone.',
        deleteFailed: 'Failed to delete the task.',
        editFailed: 'Failed to save task changes.',
        editTitleRequired: 'Title is required.',
        editSave: 'Save Changes',
        saving: 'Saving...',
        editTitle: 'Title',
        editDescription: 'Description',
        editPriority: 'Priority',
        editAssignee: 'Assignee',
        badgeChat: 'Chat Auto-Task',
        badgeDirect: 'Direct',
        toolCalls: 'tool',
        toolCallsPlural: 'tools',
        tabResult: 'Result Output',
        tabEvents: 'Run Timeline',
        noEvents: 'No run timeline events recorded yet.',
        noResult: 'No written result for this task yet.',
        loadingEvents: 'Loading run timeline...',
        close: 'Close',
        viewResult: 'Result',
        viewTimeline: 'Timeline',
        runNow: 'Run',
        running: 'Running...',
        statusRunning: 'Running',
        needsApproval: 'Needs Approval',
        empty: 'Empty',
        createTask: 'Create Task',
      },
      cron: {
        title: 'Scheduled Tasks',
        tabBoard: 'Task Board',
        tabCron: 'Cron Schedules',
        empty: 'No automated cron schedules registered in gateway.',
        active: 'Active',
        paused: 'Paused',
        lastRun: 'Last executed',
        nextRun: 'Next run',
        assignedTo: 'Assigned Agent',
        schedule: 'Schedule',
        skills: 'Required Skills',
      },
      messenger: {
        title: 'Agent Messenger',
        searchPlaceholder: 'Search agent or department...',
        activeAgent: 'Active',
        noSpeech: 'No recent message',
        allAgents: 'All Agents',
        switchAgent: 'Switch Agent',
        emptySearch: 'No agents match your search.',
      },
      modelPriority: {
        title: 'Model priority',
        help: 'The first model becomes the agent primary. Up to {{max}} unique models.',
        loading: 'Loading model priority...',
        primary: 'Primary',
        up: 'Move {{model}} up',
        down: 'Move {{model}} down',
        remove: 'Remove {{model}}',
        save: 'Save priority',
        saving: 'Saving priority...',
        saved: 'Model priority saved.',
        loadError: 'Unable to load model priority.',
        saveError: 'Unable to save model priority.',
        mismatch: 'The saved priority does not match. Try saving again.',
        retry: 'Retry',
        empty: 'No model priority yet. Add a detected model.',
        select: 'Select a detected model',
        add: 'Add model',
        noModels: 'No models detected. Test the connection to load options.',
        limit: 'Limit of {{max}} models reached.',
      },
      lang: {
        switch: 'Switch Language',
        id: 'Bahasa Indonesia',
        en: 'English',
      },
    },
  },
};

const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('hermes_lang') || 'id' : 'id';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'id',
    interpolation: {
      escapeValue: false,
    },
  });

export function changeLanguage(lang: 'id' | 'en'): void {
  i18n.changeLanguage(lang);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('hermes_lang', lang);
  }
}

export default i18n;
